import router from '../../../router'
import { signupProps } from './properties'

export const setTenantSignupId = (state, payload) => {

    state.props = JSON.parse(JSON.stringify(signupProps))
    state.props.id = payload   
    router.push('/signup/step1') 
    
}


// WEBPACK FOOTER //
// ./src/store/modules/signup/mutations.js